export interface IDispatcherDashboardCount {
  openCases?: number;
  readyForPayment?: number;
  followUp?: number;
  pendingPayment?: number;
  pendingFeedback?: number;
}

export const defaultValue: Readonly<IDispatcherDashboardCount> = {
  openCases: 0,
  readyForPayment: 0,
  followUp: 0,
  pendingPayment: 0,
  pendingFeedback: 0
};
